import { useEffect } from "react"
import { JugglingScreen } from "@motley/design"
import { windowMessageType } from "@/auth"
import { invariant } from "@/utils"

type Props = {
  result: "success" | "error" | "cancelled"
  refreshToken?: string
  error?: string
  state?: string
}

export default function OAuthResult({
  result,
  refreshToken,
  error,
  state,
}: Props) {
  useEffect(() => {
    const opener = window.opener as WindowProxy | undefined
    invariant(opener)

    opener.postMessage(
      {
        type: windowMessageType,
        result,
        refreshToken,
        error,
        state,
      },
      window.location.origin,
    )

    window.close()
  }, [result, refreshToken, error, state])

  return <JugglingScreen />
}
